require( './formdata-polyfill' );

var forms = (function( $ ) {

	var $forms;

	var $get_forms;

	var _init = function() {
		$forms = $( '.crate-form[method="POST"]' );

		if ( $forms.length > 0 ) {
			$forms.each( init_forms );
		}

		$get_forms = $( '.crate-form[method=GET]' );

		if ( $get_forms.length > 0 ) {
			$get_forms.each( _init_get_forms );
		}
	};

	var _init_get_forms = function() {
		var $form = $( this );
		var form_id = $form.attr( 'id' );

		$form.find( 'a.submit-anchor' ).on( 'click', { form_id: form_id }, _submit_event_get_form );

		_init_selects( $form );

		$form.find( '.field-wrap.conditional' ).each( function() {
			var conditions = $( this ).data( 'conditions' );

			_toggle_conditional_field( conditions, $( this ) );

			for ( var i = 0; i < conditions.length; i++ ) {
				$form.find( conditions[ i ].field_js )
					.on( 'change', {
						conditions: conditions,
						subject_id: $( this ).attr( 'id' )
					}, _check_condition_event );
			}
		} );

		$form.find( '.field-wrap.same-as' ).each( function() {
			_attach_same_as_handlers( $( this ).data( 'same-as' ), $( this ).find( ':input' ).attr( 'id' ) );
		} );

		$form.find( '.tooltip-toggle' ).on( 'click', _toggle_tooltip );
	};

	var _submit_event_get_form = function( e ) {
		$( '#' + e.data.form_id ).trigger( 'submit' );

		e.preventDefault();
	};

	var _init_selects = function( $form ) {
		if ( $form.find( 'select' ).length > 0 ) {
			$form.find( 'select' ).each( function() {
				var $select = $( this );

				var options = {
					dropdownParent: $select.closest( '.field-wrap' )
				};

				var max_selection = $select.data( 'max-selection' );

				if ( max_selection ) {
					options.maximumSelectionLength = max_selection;
				}

				var min_input = $select.data( 'min-input' );

				if ( min_input ) {
					options.minimumInputLength = min_input;
				}

				$select.select2( options );
			} );
		}
	};

	var init_forms = function() {
		var $form = $( this );
		var form_id = $form.attr( 'id' );

		$form.find( 'input[type="submit"]' ).on( 'click', { form_id: form_id }, _submit_event );
		$form.find( 'a.submit-anchor' ).on( 'click', { form_id: form_id }, _submit_event );

		$form.on( 'submit', _prevent_default );

		if ( ScriptData[form_id + '_should_autosave'] ) {
			$form.find( ':input' ).on( 'change', { form_id: form_id }, _change_event );
			_save( form_id, true );
		}

		_init_selects( $form );

		$form.on( 'saved', { form_id : form_id }, _setup_conditional_fields );

		$form.find( '.field-wrap.same-as' ).each( function() {
			_attach_same_as_handlers( $( this ).data( 'same-as' ), $( this ).find( ':input' ).attr( 'id' ) );
		} );

		$form.find( '.tooltip-toggle' ).on( 'click', _toggle_tooltip );
	};

	var _setup_conditional_fields = function( e ) {
		var $form = $( '#' + e.data.form_id );

		$form.find( '.field-wrap.conditional' ).each( function() {
			var conditions = $( this ).data( 'conditions' );

			_toggle_conditional_field( conditions, $( this ) );

			for ( var i = 0; i < conditions.length; i++ ) {
				$form.on( 'saved', { conditions: conditions, subject_id: $( this ).attr( 'id' ) }, _check_condition_event );
			}
		} );

		$form.off( 'saved', _setup_conditional_fields );
	};

	var _prevent_default = function( e ) {
		e.preventDefault();
	};

	var _attach_same_as_handlers = function( same_as, subject_id ) {
		var $subject = $( '#' + subject_id );

		$( same_as.field_js ).each(
			function() {
				if ( ! $( this ).is( $subject ) ) {
					$( this ).on( 'change', { same_as: same_as, subject_id: $subject.attr( 'id' ) }, _set_same_as_event );
				}
			}
		);

		for ( var i = 0; i < same_as.conditions.length; i++ ) {
			$( same_as.conditions[ i ].field_js )
				.on( 'change', {
					same_as: same_as,
					subject_id: $subject.attr( 'id' )
				}, _set_same_as_event );
		}
	};

	var _set_same_as_event = function ( e ) {
		var same_as = e.data.same_as;
		var $subject = $( '#' + e.data.subject_id );

		var value = $( same_as.field_js ).val();

		if ( 'checkbox' === $subject.attr( 'type' ) ) {
			value = $( same_as.field_js ).is(':checked');
		}

		_set_same_as( same_as, $subject, value );
	};

	var _set_same_as = function ( same_as, $subject, value ) {
		var should_set = true;

		if ( typeof same_as.conditions !== 'undefined' ) {
			should_set = _conditions_met( same_as.conditions );
		}

		if ( should_set ) {
			switch ( $subject.attr( 'type' ) ) {
				case 'checkbox':
					if ( value ) {
						$subject.attr( 'checked', 'checked' );
					} else {
						$subject.removeAttr( 'checked' );
					}
					break;
				default:
					$subject.val( value );
			}

		}
	};

	var _check_condition_event = function ( e ) {
		var conditions = e.data.conditions;
		var $subject   = $( '#' + e.data.subject_id );

		_toggle_conditional_field( conditions, $subject );
	};

	var _toggle_conditional_field = function( conditions, $subject ) {
		if ( _conditions_met( conditions ) ) {
			if ( $subject.hasClass( 'is-required' ) ) {
				$subject.find( ':input' ).attr( 'required', 'required' );
			}

			$subject.slideDown( 400 );

			setTimeout( function() {
				$( $subject.closest( 'form' ) ).trigger( 'field_shown', [ $subject.attr( 'id' ) ] );
			}, 410 );
		} else {
			if ( $subject.hasClass( 'is-required' ) ) {
				$subject.find( ':input' ).removeAttr( 'required' );
			}

			$subject.slideUp( 400 );

			setTimeout( function() {
				$( $subject.closest( 'form' ) ).trigger( 'field_hidden', [ $subject.attr( 'id' ) ] );
			}, 410 );
		}
	};

	var _conditions_met = function( conditions ) {
		var cond_satisfied = false;

		for ( var i = 0; i < conditions.length; i++ ) {
			var condition = conditions[ i ];

			var $fields = $( condition.field_js );

			$fields.each( function() {
				var test_val = $( this ).val();

				if ( 'checkbox' ===  $( this ).attr( 'type' ) ) {
					test_val = $( this ).is( ':checked' ) ? 1 : 0;
				}

				if ( 'radio' === $( this ).attr( 'type' ) ) {
					test_val = $( this ).is( ':checked' ) ? 1 : 0;
				}

				switch ( condition.compare ) {
					case '=':
						cond_satisfied = test_val === condition.value;
						break;
					case '!=':
						cond_satisfied = test_val !== condition.value;
						break;
					case '>':
						cond_satisfied = test_val > condition.value;
						break;
					case '>=':
						cond_satisfied = test_val >= condition.value;
						break;
					case '<':
						cond_satisfied = test_val < condition.value;
						break;
					case '<=':
						cond_satisfied = test_val <= condition.value;
						break;
					case 'has_notice':
						cond_satisfied = $( this ).closest( '.field-wrap' ).find( '.field-notice > .' + condition.value ).length > 0;
						break;
					case 'not_has_notice':
						cond_satisfied = ! ( $( this ).closest( '.field-wrap' ).find( '.field-notice > .' + condition.value ).length > 0 );
						break;
				}

				if ( ! cond_satisfied ) {
					return false;
				}
			} );

			if ( ! cond_satisfied ) {
				break;
			}
		}

		return cond_satisfied;
	};

	var _toggle_tooltip = function ( e ) {
		// $( this ).closest( '.field-tooltip' ).toggleClass( 'open' );
		// $( this ).next( '.tooltip-content' ).fadeToggle();

		e.preventDefault();
	};

	var _submit_event = function( e ) {
		_save( e.data.form_id, false );

		$( '#' + e.data.form_id ).trigger( 'submission-attempted' );

		e.preventDefault();
	};

	var _change_event = function( e ) {
		_save( e.data.form_id, true );
	};

	var _save = function( form_id, autosave ) {
		var $form = $( '#' + form_id );

		if ( ! autosave || _submission_attempted( $form ) ) {
			_show_spinner( form_id );
		}

		var nonce = form_id + '_submit_nonce';
		var action = 'crate_submit_form_' + form_id;
		var response = _submit_response;

		if ( autosave ) {
			nonce = form_id + '_autosave_nonce';
			action = 'crate_autosave_form_' + form_id;
			response = _autosave_response;
		}

		var data = new FormData();
		data.append( 'crate_form_action', true );
		data.append( 'action', action );
		data.append( 'form_id', form_id );
		data.append( nonce, ScriptData[ nonce ] );
		data.append( 'ajax_data', ScriptData[ form_id + '_ajax_data' ] );
		data.append( 'current_uri', window.location.href );

		var form_data = new FormData( $form[0] );

		var entries = form_data.entries();
		var next;
		while ( ( next = entries.next() ) && next.done === false ) {
			var key = 'form_data[' + next.value[ 0 ] + ']';
			var value = next.value[ 1 ];

			var prev_value = data.get( key );
			if ( prev_value ) {
				value = prev_value + ',' + value;
			}

			data.set( key, value );
		}

		var ajax_data = ScriptData[ form_id + '_ajax_data' ];
		for ( var i in ajax_data ) {
			if ( ajax_data.hasOwnProperty( i ) ) {
				data.append( 'ajax_data[' + i + ']', ajax_data[ i ] );
			}
		}

		$.ajax( {
			type: 'POST',
			url: ScriptData.ajaxurl,
			data: data,
			success: response,
			processData: false,
			contentType: false
		} );
	};

	var _submit_response = function ( response ) {
		var $form = $( '#' + response.form_id );

		_set_submission_attempted( $form );
		_apply_field_notices( $form, response.field_notices );
		_apply_field_values( $form, response.new_values );

		var notes_applied = _apply_notes( $form, response );

		if ( notes_applied ) {
			if ( response.scroll && ( Object.keys(response.form_notices).length > 0 || Object.keys(response.form_errors).length > 0 ) ) {
				$( 'html, body' ).animate( {
					scrollTop: $form.offset().top - 150
				}, 1000 );
			}
		}

		_hide_spinner( response.form_id );

		if ( response.success ) {
			$form.trigger( 'submit_success', response );
		} else {
			$form.trigger( 'submit_failure', response );
		}

		if ( response.redirect ) {
			setTimeout( function() {
				window.location.href = response.redirect;
			}, 1500 );
		}

		if ( response.hide_fields ) {
			$form.find( '.crate-form-inner-content' ).remove();
		}

		$form.trigger( 'saved', response );
	};

	var _autosave_response = function( response ) {
		var $form = $( '#' + response.form_id );
		_apply_field_notices( $form, response.field_notices );
		_apply_field_values( $form, response.new_values );

		if ( _submission_attempted( $form ) ) {
			_apply_notes( $form, response );
		}

		if ( response.success ) {
			$form.trigger( 'autosave_success', response );
		} else {
			$form.trigger( 'autosave_failure', response );
		}

		_hide_spinner( response.form_id );

		$form.trigger( 'saved', response );
	};

	var _apply_notes = function( $form, response ) {
		var form_notices  = _apply_form_notices( $form, response.form_notices );
		var form_errors   = _apply_form_errors( $form, response.form_errors );
		var field_errors  = _apply_field_errors( $form, response.field_errors );

		return form_notices || form_errors || field_errors;
	};

	var _apply_form_notices = function ( $form, notices ) {
		var $notices_div = $form.find( '.form-notices' );

		$notices_div.html('');

		if ( Object.keys(notices).length > 0 ) {
			$notices_div.addClass( 'has-notices' );

			for ( var notice_key in notices ) {
				if ( notices.hasOwnProperty( notice_key ) ) {
					var notice_html = '<span class="' + notice_key + '">' + notices[ notice_key ] + '</span>';
					$notices_div.append( notice_html );
				}
			}

			return true;
		} else {
			$notices_div.removeClass( 'has-notices' );
			return false;
		}
	};

	var _apply_form_errors = function ( $form, errors ) {
		var $errors_div = $form.find( '.form-errors' );

		$errors_div.html('');

		if ( Object.keys(errors).length > 0 ) {
			$errors_div.addClass( 'has-errors' );

			for ( var error_key in errors ) {
				if ( errors.hasOwnProperty( error_key ) ) {
					var error_html = '<span class="' + error_key + '">' + errors[ error_key ] + '</span>';
					$errors_div.append( error_html );
				}
			}
			return true;
		} else {
			$errors_div.removeClass( 'has-errors' );
			return false;
		}
	};

	var _apply_field_notices = function( $form, notices ) {
		var notices_exist = false;

		if ( Object.keys( notices ).length > 0 ) {
			for ( var field_id in notices ) {
				if ( notices.hasOwnProperty( field_id ) ) {
					var field_has_notices = _apply_single_field_notices( $form, field_id, notices[ field_id ] );

					if ( ! notices_exist ) {
						notices_exist = field_has_notices;
					}
				}
			}
		}

		return notices_exist;
	};

	var _apply_single_field_notices = function ( $form, field_id, notices ) {
		var $notices_div = $form.find( '#' + field_id + '-field-notice' );

		$notices_div.html('');

		if ( Object.keys(notices).length > 0 ) {
			$( '#field-wrap-' + field_id ).addClass( 'has-notices' );

			for ( var notice_key in notices ) {
				if ( notices.hasOwnProperty( notice_key ) ) {
					var notice_html = '<span class="' + notice_key + '">' + notices[ notice_key ] + '</span>';
					$notices_div.append( notice_html );
				}
			}
			return true;
		} else {
			$( '#field-wrap-' + field_id ).removeClass( 'has-notices' );
			return false;
		}
	};

	var _apply_field_errors = function( $form, errors ) {
		var errors_exist = false;

		if ( Object.keys( errors ).length > 0 ) {
			for ( var field_id in errors ) {
				if ( errors.hasOwnProperty( field_id ) ) {
					var field_has_errors = _apply_single_field_errors( $form, field_id, errors[ field_id ] );

					if ( ! errors_exist ) {
						errors_exist = field_has_errors;
					}
				}
			}
		}

		return errors_exist;
	};

	var _apply_single_field_errors = function ( $form, field_id, errors ) {
		var $errors_div = $form.find( '#' + field_id + '-field-error' );

		$errors_div.html('');

		if ( Object.keys(errors).length > 0 ) {
			$( '#field-wrap-' + field_id ).addClass( 'has-errors' );

			for ( var error_key in errors ) {
				if ( errors.hasOwnProperty( error_key ) ) {
					var error_html = '<span class="' + error_key + '">' + errors[ error_key ] + '</span>';
					$errors_div.append( error_html );
				}
			}
			return true;
		} else {
			$( '#field-wrap-' + field_id ).removeClass( 'has-errors' );
			return false;
		}
	};

	var _apply_field_values = function( $form, values ) {
		if ( Object.keys( values ).length > 0 ) {
			for ( var field_id in values ) {
				if ( values.hasOwnProperty( field_id ) ) {
					var $field = $( '#field_' + field_id );

					if ( 'checkbox' === $field.attr( 'type' ) ) {
						if ( values[field_id] ) {
							$field.attr( 'checked', 'checked' );
						} else {
							$field.removeAttr( 'checked' );
						}
					} else {
						$field.val( values[ field_id ] );
					}
				}
			}
		}
	};

	var _show_spinner = function ( form_id ) {
		var $form = $( '#' + form_id );

		$form.find( '.ajax-spinner' ).addClass( 'active' );
	};

	var _hide_spinner = function ( form_id ) {
		var $form = $( '#' + form_id );

		$form.find( '.ajax-spinner' ).removeClass( 'active' );
	};

	var _submission_attempted = function ( $form ) {
		return ( $form.data( 'submission-attempted' ) === 'true' );
	};

	var _set_submission_attempted = function ( $form ) {
		$form.data( 'submission-attempted', 'true' );
	};

	$( document ).ready( _init );

	return {
		init_forms: init_forms
	};

})( jQuery );

module.exports = forms;